import { Tabs as MUITabs, Tab, Grid } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import React, { memo, useCallback, useState } from 'react';
import { usePrerequisites } from '../../contexts/Prerequisites';

export const CustomMuiTabs = styled(MUITabs)(({ theme }) => ({
	minHeight: theme.spacing(5),
	'& .MuiTab-root': {
		color: theme.palette.background.paper,
		textTransform: 'capitalize',
		minHeight: theme.spacing(5),
		height: theme.spacing(5),
		borderTopLeftRadius: 5,
		borderTopRightRadius: 5,
		backgroundColor: theme.palette.action.disabled,
		marginLeft: theme.spacing(0.5),
		'&:hover': {
			backgroundColor: theme.palette.action.active,
			color: theme.palette.background.paper
		},
		'&.Mui-selected': {
			'&:hover': {
				backgroundColor: theme.palette.background.default
			},
			backgroundColor: theme.palette.background.paper,
			color: theme.palette.text.primary
		}
	}
}));

const Tabs = ({ tabs = [], tab, onChange, slotProps, ...rest }) => {
    const theme = useTheme();
	const [{ strings }] = usePrerequisites();
    const [tabIndex, setTabIndex] = useState(tabs?.length > 0? 0 : -1);
    const controlled = typeof tab !== 'undefined';
    const activeTab = controlled ? tab : tabIndex;
    const handleOnTabChange = useCallback(
        (event, tabIndex) => {
            if (controlled) {
                if (typeof onChange === 'function') {
                    onChange(event, tabIndex);
                }
            }
            else {
                setTabIndex(tabIndex);
            }
			
		},
		[controlled, onChange]
	);
	const { Component: TabComponent, ...tabProps } = { ...tabs[activeTab] };
	

    return (
		<Grid container>
			<Grid size={12} className="no-print" item sx={{ padding: theme.spacing(0, 1) }}>
				<CustomMuiTabs
					variant="scrollable"
					allowScrollButtonsMobile
					indicatorColor={theme.palette.primary.light}
					{...rest}
					value={activeTab}
					onChange={handleOnTabChange}
				>
					{tabs.map(({ Icon, label, name, hide, ...others }, i) =>(
						 !hide ? (
							<Tab
								iconPosition="start"
								icon={!!Icon && <Icon fontSize="inherit" />}
								label={others.isISARAER ? label : strings[label] || label}
								variant="small"
								{...slotProps?.tab}
								key={`custom-tab-${i}`}
							/>
						) : null
					))}
				</CustomMuiTabs>
			</Grid>
			<Grid size={12} item className={'TabComponentWrapper'}>
				{!!TabComponent && <TabComponent {...slotProps?.tabComponent} {...tabProps} />}
			</Grid>
		</Grid>
	);
}


export default memo(Tabs);